import {MetricValueUpdate} from "../../models/notification/MetricValue";
import {BaseEvent} from "../BaseEvent";


export class UpdateMetricValueNtf extends BaseEvent {
  public static NAME = 'updateMetricValue';
  public value: MetricValueUpdate;

  constructor(value: MetricValueUpdate) {
    super(UpdateMetricValueNtf.NAME);
    this.value = value;
  }
}
